import {
  Component,
  OnInit,
  Input
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  ActivatedRoute
} from '@angular/router';
@Component({
  selector: 'form-common-fields',
  templateUrl: 'form-common-fields.component.html',
  styleUrls: ["../../../../assets/css/common.css"]
})
export class FormCommonFieldsComponent implements OnInit {
  @Input() commonFields: UntypedFormGroup;
  childForm: UntypedFormGroup;
  loading = false;
  returnUrl: string;
  response: string;
  submitted = false;
  xmlContent: any;
  selectedServerValue: string = 'SecureDataIntegrationToolkit';
  constructor(
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder
  ) {}
  ngOnInit() {
    this.childForm = this.formBuilder.group({
      userId: ['', Validators.required],
      password: ['', Validators.required],
      server: [''],
      url: [''],
      response: [''],
      validateRequest: [''],
      validateResponse: ['']
    });
    this.setDefaultValues();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }
  setDefaultValues() {
    this.childForm.patchValue({
      server: 'SecureDataIntegrationToolkit'
    });
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.childForm.controls;
  }
  selectServerValue(event) {
    this.selectedServerValue = event.target.value;
  }
}
